import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}/contratos`

export default {
    ListarAtasDirex() {
        return axiosJwt
            .get(`${api}/atadirex/ListarTodos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    SalvarAtaDirex(atadirex) {
        return axiosJwt
            .post(`${api}/atadirex/inserir`, atadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    AtualizarAtaDirex(atadirex) {
        return axiosJwt
            .post(`${api}/atadirex/atualizar`, atadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    CancelarAtaDirex(atadirex) {
        return axiosJwt
            .post(`${api}/atadirex/CancelarAtaDirex`, atadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ConcluirAtaDirex(atadirex) {
        return axiosJwt
            .post(`${api}/atadirex/ConcluirAtaDirex`, atadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ReabrirAtaDirex(atadirex) {
        return axiosJwt
            .post(`${api}/atadirex/ReabrirAtaDirex`, atadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ExcluirAtaDirex(atadirex) {
        return axiosJwt
            .post(`${api}/atadirex/excluir`, atadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarFuncionariosRM(id) {
        return axiosJwt
            .get(`${api}/atadirex/ListarFuncionariosRM/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarUnidadesRM() {
        return axiosJwt
            .get(`${api}/atadirex/ListarUnidadesRM`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterPorId(id) {
        return axiosJwt
            .get(`${api}/atadirex/ObterPorId/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterInformacoesGeraisAta(id) {
        return axiosJwt
            .get(`${api}/atadirex/ObterInformacoesGeraisAta/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarProcessosAtaDirex(id) {
        return axiosJwt
            .get(`${api}/atadirex/ListarProcessosAta/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcessoGedocPorNumero(numeroprocesso, modoCadastro) {
        return axiosJwt
            .get(
                `${api}/atadirex/ObterProcessoGedocPorNumero/${numeroprocesso}/${modoCadastro}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    SalvarProcessoAtaDirex(processoatadirex) {
        return axiosJwt
            .post(`${api}/atadirex/InserirProcesso`, processoatadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    AtualizarProcessoAtaDirex(processoatadirex) {
        return axiosJwt
            .post(`${api}/atadirex/AtualizarProcesso`, processoatadirex)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    EnviarProcessosPorEmail(id, listaprocessosatadirex) {
        return axiosJwt
            .post(`${api}/atadirex/EnviarProcessosPorEmail`, {
                idAta: id,
                lista: listaprocessosatadirex
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarAnexos(id) {
        return axiosJwt
            .get(`${api}/atadirex/ListarAnexos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ExcluirAnexo(id) {
        return axiosJwt
            .get(`${api}/atadirex/ExcluirAnexo/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadAnexo(id) {
        return axiosJwt
            .get(`${api}/atadirex/DownloadAnexoPorId/${id}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAnexo(documento) {
        const formData = new FormData()
        formData.append('idAnexo', documento.idAnexo)
        formData.append('idProcessoAta', documento.idProcessoAta)
        formData.append('vcDescricaoAnexo', documento.vcDescricaoAnexo)
        formData.append('nuSituacaoAnexo', 1)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)

        return axiosJwt
            .post(`${api}/atadirex/InserirAnexo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
